import styled from "styled-components";

export const DescriptionContainer = styled.div`
  margin: 0 0 2rem;

  .ant-card {
    border-radius: 10px;

    border-color: transparent;
    background: ${({ theme }) => theme.colors.modalBackgroundColor};
  }

  .ant-card-head {
    border-color: ${({ theme }) => theme.colors.backgroundColor};
  }

  .ant-card-head-title {
    padding: 1rem 0;
    font-size: 20px;
    font-weight: 400;

    color: ${({ theme }) => theme.colors.textColor};
  }

  p {
    white-space: pre-wrap;

    span p img {
      max-width: 100%;
    }
  }

  img {
    height: auto;
  }
`;
